import { getCohortSectionUrl } from "@pathwright/web/src/modules/utils/urls"
import { inviteCardRoute } from "invitation/invite/routes"
import { invitationCardRoute } from "invitation/list/routes"
import { createCardRoutes } from "lib/core/routing/card-routing"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import MessageCard from "message/components/MessageCard"
import { clearMessageContext, loadMessageContext } from "message/middleware"
import { loadResource, loadResourcePath } from "path/middleware"
import {
  CurrentUserReportCardContainer,
  CurrentUserResourceReportCardContainer,
  registrationConfigCardRoutes,
  reportCardRoutes
} from "profile/routes"
import MemberListCard from "./list/MemberListCard"

const loadMembers = (nextState, replaceState, callback) => {
  loadResource(nextState, "path" /* defaultSection */).then(() => {
    const { can_facilitate } = App.getStore("resource").request.permissions()
    if (!can_facilitate) {
      // Redirect to the path if user cannot moderate the cohort.
      callback(replaceState(getCohortSectionUrl()))
    }

    App.getStore("member").action.loadMembers()
    callback()
  })
}

const getSectionDefaultLaunchedFrom = ({ match }) => {
  const { resourceSlug, cohortId, section } = match.params
  return `/library/${resourceSlug}/${cohortId}/${section}/`
}

const messageRoute = {
  path: "message/:userId(\\d+)?/",
  component: MessageCard,
  middleware: loadMessageContext,
  leaveMiddleware: clearMessageContext,
  getDefaultLaunchedFrom: getSectionDefaultLaunchedFrom
}

const cardRoutes = {
  member: {
    component: MemberListCard,
    middleware: loadMembers,
    getDefaultLaunchedFrom: getSectionDefaultLaunchedFrom,
    childCards: {
      ...inviteCardRoute,
      ...invitationCardRoute,
      ...registrationConfigCardRoutes,
      message: messageRoute,
      report: {
        ...reportCardRoutes.report,
        path: ":userId/:pathId(\\d+)?/",
        reversePath: "../../",
        getDefaultLaunchedFrom: getSectionDefaultLaunchedFrom,
        childCards: {
          ...reportCardRoutes.report.childCards,
          resourceReport: {
            ...reportCardRoutes.report.childCards.resourceReport,
            getDefaultLaunchedFrom: getSectionDefaultLaunchedFrom
          }
        }
      }
    }
  },
  performance: {
    component: CurrentUserReportCardContainer,
    middleware: loadResourcePath,
    getDefaultLaunchedFrom: getSectionDefaultLaunchedFrom,
    childCards: {
      resourceReport: {
        path: ":collectionResourcePathId(\\d+)/",
        component: (props) => (
          <CurrentUserResourceReportCardContainer
            {...props}
            pathId={parseInt(props.match.params.collectionResourcePathId)} // use resource path id
          />
        )
      }
    }
  }
}

const basePath = "/library/:resourceSlug/:cohortId(\\d+)/:section?/"

export default createCardRoutes(basePath, cardRoutes, LibraryResourceContainer)
